import React, { useState } from 'react';
import { Button } from '@progress/kendo-react-buttons';
import { Loader2 } from 'lucide-react';
export function AuthServerLoginButton({
  redirectTo = '/',
  // Use OIDC_LOGIN_URL for cookie-based authentication
  loginUrl = process.env.OIDC_LOGIN_URL,
  label = 'Sign in',
  redirectingLabel = 'Redirecting...',
  onClick,
  ...buttonProps
}) {
  const [loading, setLoading] = useState(false);

  const handleClick = async (e) => {
    onClick?.(e);
    if (e.defaultPrevented) return;

    setLoading(true);

    try {
      // Redirect to the login URL which handles authentication server-side
      // The auth server will set cookies and redirect back to the app
      if (loginUrl) {
        window.location.href = loginUrl;
      } else {
        throw new Error('Login URL not configured');
      }
    } catch (err) {
      console.error('Login redirect failed:', err);
      setLoading(false);
    }
  };

  return (
    <>
      <Button onClick={handleClick} disabled={loading} {...buttonProps}>
        {loading ? (
          <span className='sso-login__btnContent'>
            <Loader2 className='sso-login__btnSpinner' />
            {redirectingLabel}
          </span>
        ) : (
          label
        )}
      </Button>
    </>
  );
}

export default AuthServerLoginButton;
